"use client";

import { ListBulletIcon } from "@heroicons/react/24/solid";
import NoSsr from "@mui/material/NoSsr";
import { usePathname } from "next/navigation";
import { isMobile } from "react-device-detect";
import { twMerge } from "tailwind-merge";

import { useSymbol } from "@/features/analysis/hooks/use-symbol";
import { useBottomPanel } from "@/hooks/use-bottom-panel";
import { useLang } from "@/hooks/use-lang";

import { NavigationClosure } from "./NavigationClosure";

const NavigationPanel = () => {
  const { t } = useLang();
  const { symbol } = useSymbol();
  const { Panel, closePanel, openPanel } = useBottomPanel();
  const pathname = usePathname();
  const isAnalysisOrientationPage = /\/analysis\/\w+/i.test(pathname);

  if (!isAnalysisOrientationPage) return null;

  return (
    <NoSsr>
      <button
        type="button"
        onClick={openPanel}
        className={twMerge(
          "fixed right-5 z-50 hidden aspect-1 h-12 shrink-0 cursor-pointer items-center rounded-full bg-zinc-800 transition-all hover:scale-110 hover:bg-zinc-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 group-[:has([data-hidden='true'])]:flex",
          isMobile ? "bottom-5" : "bottom-20"
        )}
        aria-label="open navigation dialog"
      >
        <ListBulletIcon className="m-auto h-7 w-7 shrink-0 text-white" />
      </button>
      <Panel title={t.analysis.navigation.listOfPages}>
        <NavigationClosure symbol={symbol} onLinkClick={closePanel} />
      </Panel>
    </NoSsr>
  );
};

export default NavigationPanel;
